
import { AdminResourceCard } from "@/components/resource/AdminResourceCard";
import { TraineeResourceCard } from "@/components/resource/TraineeResourceCard";

interface ResourceGridProps {
  resources: any[];
  isTrainee?: boolean;
}

export const ResourceGrid = ({ resources, isTrainee = true }: ResourceGridProps) => {
  if (!resources || resources.length === 0) {
    return null;
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {resources.map((resource) => (
        isTrainee ? (
          <TraineeResourceCard
            key={resource.id}
            resource={resource}
          />
        ) : (
          <AdminResourceCard
            key={resource.id}
            resource={resource}
          />
        )
      ))}
    </div>
  );
}
